import { Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { BroadcastService } from './broadcast.service';
import { NotificationService } from '@progress/kendo-angular-notification';
import { AppConstants } from '../constants/app.constants';
import { ApiService } from './api.service';
import * as FileSaver from 'file-saver';
import { PerformsearchService } from './performsearch.service';
import { Router } from '@angular/router';
var global: any = global || window;

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private tabEvent = new BehaviorSubject('');
  public currentTabEvent = this.tabEvent.asObservable();
  public callStatus: BehaviorSubject<boolean>;
  readonly constants = AppConstants;
  filterData = {
    category: "",
    company: "",
    //location: "",
    standard: "",
    subCategory: "",
    facilityLocation: "",
    state: ""
  };
  apiDateTime: any = {}
  isSearchResult: Boolean = false;
  readonly applyStyling: any = [
    {
      "colCount": 6, "width": "11%", "marginright": "5%"
    }, {
      "colCount": 5, "width": "15%", "marginright": "5%"
    }, {
      "colCount": 4, "width": '20%', "marginright": "5%"
    }, {
      "colCount": 3, "width": "25%", "marginright": "8%"
    }, {
      "colCount": 2, "width": "30%", "marginright": "20%"
    }];

  constructor(private _broadcast: BroadcastService,
    private notificationService: NotificationService,
    private _performSearch: PerformsearchService,
    private router: Router,
    private _api: ApiService) {
    this.callStatus = new BehaviorSubject(false);

  }

  onCusLogoImageError(event: any, originalUrl: string) {
    if (originalUrl) {
      const lastDotIndex = originalUrl.lastIndexOf('.');
      if (lastDotIndex !== -1) {
        const extension = originalUrl.substring(lastDotIndex + 1);
        const lowercaseUrl = originalUrl.substring(0, lastDotIndex + 1) + extension.toLowerCase();
        // Prevent infinite loop if lowercase URL also fails
        if (event.target.src !== lowercaseUrl) {
          event.target.src = lowercaseUrl;
          return;
        }else{
          event.target.style.display = 'none';
        }
      }
    }

    // If original or lowercase URL failed, hide the image
     event.target.style.display = 'none';
  }


  updateTabEvent(evtMsg: string) {
    this.tabEvent.next(evtMsg)
  }

  public addBreadScrumTitle(flag: boolean) {
    this.callStatus.next(flag);
  }

  findCategoryMinHeight() {
    let advHeight = document?.querySelector(".right.search")?.clientHeight || 0;
    let headerHeight = document?.querySelector(".detail-search")?.clientHeight || 0;
    this._broadcast.setHeight((advHeight + headerHeight) + 'px' || 'auto');
  }

  showNotify(notificationTemplate: any, hideAfter: number): void {
    this.notificationService.show({
      content: notificationTemplate,
      position: { horizontal: 'center', vertical: 'top' },
      animation: { type: 'fade', duration: 400 },
      type: { style: 'error', icon: true },
      closable: false,
      hideAfter: hideAfter
    });
  }

  showErrorMsg(errorMsg: any): void {
    if (errorMsg != "") {
      this._broadcast.setErrorMessage({ iShowError: true, message: errorMsg });
    } else {
      this._broadcast.setErrorMessage({ iShowError: false, message: errorMsg });
    }
  }

  checkErrorMessage(fromSearch: boolean) {
    let searchfeild: string = sessionStorage.getItem('searchfeild') || '';
    let advFilter = JSON.parse(sessionStorage.getItem('advFilter') || 'null') || {};
    if (searchfeild || advFilter.company || advFilter.category || /*advFilter.location ||*/ advFilter.standard || advFilter.subCategory
    || advFilter.facilityLocation || advFilter.state) {
      this._broadcast.setErrorMessage({ iShowError: false, message: '' });
    } else {
      fromSearch && this._broadcast.setErrorMessage({ iShowError: true, message: this.constants.ATLEAST_ONE_COLUMN_MSG });
    }
  }


  processExportData(model: any, type: any, url: any, fileName: String) {
    this._broadcast.showLoader(true);
    const header: any = this._api.getPlainHeader();
    //const headers: any = this._api.getaccessToken();
    header['responseType'] = 'blob';
    // header['Content-Type'] = 'application/json'
    this._api.post(url, model, header).subscribe(
      (res: any) => {
        this.saveExportedFiles(res, fileName + '.' + type);
        //FileSaver.saveAs(res, model.exportFor + '.' + type);
        this._broadcast.showLoader(false);
      },
      (err: any) => {
        this._broadcast.setNoDataImage({ iSDefault: false, message: err.message });
        this._broadcast.showLoader(false);
      }
    );
  }

  // export option passed two params fileData and fileName
  saveExportedFiles(fileData: any, uploadedFileName: any) {
    if (fileData && fileData != "") {
      if ((navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/iPad/i)) && (window as any)?.webkit) {
        var switchArray = {
          fileData: fileData,
          fileName: uploadedFileName
        };
        var msg = JSON.stringify(switchArray);
        (window as any)?.webkit.messageHandlers.iOS_file_download_success.postMessage(msg);
      } else if (navigator.userAgent.toLowerCase().indexOf("android") > -1 && (window as any)?.Android) {
        (window as any)?.Android.saveFileToStorage(fileData, uploadedFileName, this.constants.FILE_DOWNLOAD_SUCCESS);
      } else {
        FileSaver.saveAs(fileData, uploadedFileName);
      }
    } else {
      // console.log("File is currupted")
    }
  }

  async generateSharedLink(type: any) {
    this._broadcast.showLoader(true);
    
    // Check if we're in hasQueryParam mode by looking at current URL
    const currentUrl = window.location.href;
    const hasQueryParams = currentUrl.includes('?');
    
    if (hasQueryParams && type === 'productDetails') {
      // hasQueryParam mode - return current URL directly
      this._broadcast.showLoader(false);
      return currentUrl;
    }
    
    // Normal mode - existing functionality
    let sharedLinkObject: any = {}, gridFilter = {}, viewListingDetails = {};
    let searchfeild = sessionStorage.getItem("searchfeild") || '';
    let filteredDataVal = JSON.parse(sessionStorage.getItem('filteredDataVal') || '{}');
    let advFilter = JSON.parse(sessionStorage.getItem('advFilter') || '{}');
    let searchType = sessionStorage.getItem('searchType') || '';
    let searResult = await this.generateSearchResultData();
    let sectionData = JSON.parse(sessionStorage.getItem('sectionData') || '[]');
    let rowData = JSON.parse(sessionStorage.getItem("rowData") || '{}');
    let productToModel = JSON.parse(sessionStorage.getItem("productToModel") || '[]');
    let searchRequest = JSON.parse(sessionStorage.getItem("searchRequest") || '{}'); 
    gridFilter = JSON.parse(sessionStorage.getItem('gridFilter') || '{}');
    switch (type) {
      case 'searchResult':
        const dynamicForm = JSON.parse(sessionStorage.getItem('dynamicForm') || '{}')
        sharedLinkObject = {
          searResult,
          searchfeild,
          filteredDataVal,
          gridFilter,
          advFilter,
          searchType,
          type,
          sectionData,
          dynamicForm
        }
        break;
      case 'productDetails':
        viewListingDetails = JSON.parse(sessionStorage.getItem("viewListingDetails") || '{}');
        sharedLinkObject = {
          searResult,
          searchfeild,
          filteredDataVal,
          gridFilter,
          advFilter,
          viewListingDetails,
          type,
          searchType,
          sectionData,
          rowData,
          searchRequest
        }
        break;
      case 'modelDetails':
        viewListingDetails = JSON.parse(sessionStorage.getItem("viewListingDetails") || '{}');
        let emitValue = JSON.parse(sessionStorage.getItem("emitValue") || '{}');
        sharedLinkObject = {
          searResult,
          searchfeild,
          filteredDataVal,
          gridFilter,
          advFilter,
          emitValue,
          viewListingDetails,
          type,
          searchType,
          sectionData,
          rowData,
          productToModel,
          searchRequest
        }
        break;
      case 'categoryDetails':
        viewListingDetails = JSON.parse(sessionStorage.getItem("viewListingDetails") || '{}');
        sharedLinkObject = {
          searResult,
          searchfeild,
          filteredDataVal,
          gridFilter,
          advFilter,
          viewListingDetails,
          type,
          searchType,
          sectionData,
          rowData,
          searchRequest
        }
        break;
      default:
        // console.log('Not match');
    }
    let queryParam = this.jsonToBase64(JSON.stringify(sharedLinkObject));
    const result = await lastValueFrom<any>(this._api.post(this._api.urls.createShareableLink, {
      sharableLink: queryParam
    }, this._api.getaccessToken())).catch((err) => {
      this._broadcast.showLoader(false);      
      // console.log(err);
    })
    if(!result?.success) {
      return null;
    }
    const linkId = result.data.shareLinkDetailId;
    const link = location.protocol + '//' + location.host + '/share-link?seq=' + linkId;
    this._broadcast.showLoader(false);
    return link;
  }

  jsonToBase64(obj: any) {
    return btoa(unescape(encodeURIComponent(obj)));
  }

  base64ToJson(base64: any) {
    return decodeURIComponent(escape(window.atob(base64)));
  }

  setSharedLink(jsonData: any, type: any) {
    let data: any;
    try {
      data = JSON.parse(this.base64ToJson(jsonData));
    } catch (e) {
      this.router.navigateByUrl("404error");
    }
    data?.searResult && sessionStorage.setItem('searResult', JSON.stringify(data?.searResult));
    data?.searchfeild && sessionStorage.setItem('searchfeild', data?.searchfeild);
    data?.filteredDataVal && sessionStorage.setItem('filteredDataVal', JSON.stringify(data?.filteredDataVal));
    data?.gridFilter && sessionStorage.setItem('gridFilter', JSON.stringify(data?.gridFilter));
    data?.advFilter && sessionStorage.setItem('advFilter', JSON.stringify(data?.advFilter));
    data?.searchType && sessionStorage.setItem('searchType', data?.searchType);
    data?.rowData && sessionStorage.setItem('rowData',JSON.stringify(data?.rowData));
    data?.productToModel && sessionStorage.setItem('productToModel',JSON.stringify(data?.productToModel));
    data?.searchRequest && sessionStorage.setItem('searchRequest',JSON.stringify(data?.searchRequest));
    switch (type) {
      case 'searchResult':
        break;
      case 'productDetails':
        if (data?.viewListingDetails) {
          sessionStorage.setItem('viewListingDetails', JSON.stringify(data?.viewListingDetails));
          sessionStorage.setItem('emitValue', JSON.stringify(data?.viewListingDetails));          
        }
        break;
      case 'modelDetails':
        data?.viewListingDetails && sessionStorage.setItem('viewListingDetails', JSON.stringify(data?.viewListingDetails));
        data?.emitValue && sessionStorage.setItem('emitValue', JSON.stringify(data?.emitValue));
        break;
      case 'categoryDetails':
        if (data?.viewListingDetails) {
          sessionStorage.setItem('viewListingDetails', JSON.stringify(data?.viewListingDetails));
          sessionStorage.setItem('emitValue', JSON.stringify(data?.viewListingDetails));
        }
        break;
      default:
        // console.log('Not match');
    }
  }

  getSearchResults() {
    if (!this._performSearch.isAPIProgress && !this.isSearchResult) {
      let responseMessage = '';
      this._broadcast.showLoader(true);
      this._performSearch.getSearchResults().then((response: any) => {
        this._broadcast.showLoader(false);
        response = response.searchResults;
        if (response.success == true && response.data != null) {
          this.isSearchResult = true;
        } else if (response.success == true && response.data == null) {
          if (response.code == null) {
            responseMessage = this.constants.NO_RECORDS_FOUND;
          } else {
            responseMessage = response.message;
          }
          this._broadcast.setNoDataImage({ iSDefault: false });
          this.showErrorMsg(responseMessage);
          this.isSearchResult = false;
        } else if (response.success == false) {
          this.isSearchResult = false;
          responseMessage = response.message;
          this._broadcast.setNoDataImage({ iSDefault: false });
          this.showErrorMsg(responseMessage);
        }
      }, (err) => {
        responseMessage = err.message || this.constants.EXCEEDED_MAXIMUM_RESULT;
        this.showErrorMsg(responseMessage);
        this._broadcast.setNoDataImage({ iSDefault: false, message: responseMessage });
        this._broadcast.showLoader(false);
      });
    }
  }

  openDefaultEmailORSms(sharedLink: string, mailORsms: string, mobileType: string) {
    const encodedLink = encodeURIComponent(sharedLink);
    if (mailORsms === "mail") {
      var subject = "Link to NSF Certified Products and Systems";
      var email = '';
      return `mailto:${email}?subject=${subject}&body=${encodedLink}`;
    } else {
      const msgTo = '';
      let smsBody = '';
      const url = this.router.url;
      if (url.includes('search-result') === true) {
        smsBody = "NSF Certified Products and Systems Search Results - " + encodedLink;
      } else {
        smsBody = "NSF Certified Products and Systems Listing Details - " + encodedLink;
      }
      if (mobileType === 'ios') {
        return `sms:${msgTo}&body=${smsBody}`;
      } else {
        return `sms:${msgTo}?body=${smsBody}`;
      }
    }
  }

  copyText(inputElement: any) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }

  getColumnCount(colCount: any) {
    let colStyle = this.applyStyling.filter(
      (item: any) => item.colCount == colCount
    );
    return colStyle;
  }

  async generateSearchResultData() {
    const advSearchType = sessionStorage.getItem("advSearchType");
    let advFilter = JSON.parse(sessionStorage.getItem("advFilter") || 'null');
    let dynamicFieldsJSON = JSON.parse(sessionStorage.getItem("sectionData") || 'null');
    let searchParameters: any = [];
    let exclusiveSearchParameters: any = [];
    if (Array.isArray(dynamicFieldsJSON)) {
      dynamicFieldsJSON.forEach((dynamicField: any) => {
        let searchParam: { parameterId: string, value: string[], parameterType: string,additionalFields:string,isExclusiveFilter: any } = {
          "parameterId": "",
          "value": [],
          "parameterType": "",
          "additionalFields":"",
          "isExclusiveFilter":""            
        }
        let exclusiveSearchParameter: { parameterId: string, value: string[], parameterType: string,additionalFields:string,isExclusiveFilter: any } = {
          "parameterId": "",
          "value": [],
          "parameterType": "",
          "additionalFields":"",
          "isExclusiveFilter":""
        }
        if (dynamicField.field_value != undefined && dynamicField.field_value != "") {
          if (dynamicField.field_data_type != 'MULTISELECT') {
            searchParam.parameterId = dynamicField.field_name,
              searchParam.value.push(dynamicField.field_value),
              searchParam.parameterType = dynamicField.field_data_type
              searchParam.additionalFields = dynamicField.additionalFields
              searchParam.isExclusiveFilter = dynamicField.isExclusiveFilter

              exclusiveSearchParameter.parameterId = dynamicField.field_name,
              exclusiveSearchParameter.value.push(dynamicField.field_value),
              exclusiveSearchParameter.parameterType = dynamicField.field_data_type
              exclusiveSearchParameter.additionalFields = dynamicField.additionalFields
              exclusiveSearchParameter.isExclusiveFilter = dynamicField.isExclusiveFilter

          } else if (dynamicField.field_data_type == 'MULTISELECT') {
            searchParam.parameterId = dynamicField.field_name,
                dynamicField.field_value.forEach((fieldValue: any) => {
                  searchParam.value.push(fieldValue.key)
                })
              searchParam.parameterType = dynamicField.field_data_type
              searchParam.additionalFields = dynamicField.additionalFields
              searchParam.isExclusiveFilter = dynamicField.isExclusiveFilter

              exclusiveSearchParameter.parameterId = dynamicField.field_name,
                dynamicField.field_value.forEach((fieldValue: any) => {
                  exclusiveSearchParameter.value.push(fieldValue.key)
                })
                exclusiveSearchParameter.parameterType = dynamicField.field_data_type
                exclusiveSearchParameter.additionalFields = dynamicField.additionalFields
                exclusiveSearchParameter.isExclusiveFilter = dynamicField.isExclusiveFilter
          }
        }
        if (searchParam.parameterId != "" && searchParam.value.length > 0) {
          searchParameters.push(searchParam);
        }
        if (exclusiveSearchParameter.parameterId != "" && exclusiveSearchParameter.value.length > 0) {
          exclusiveSearchParameters.push(searchParam);
        }
      });
    }
    let searchType = sessionStorage.getItem('searchType');
    const inputData = exclusiveSearchParameters    
    const exclusiveYFilterParameters = inputData.filter((parameter: { isExclusiveFilter: string; }) => parameter.isExclusiveFilter === "Y");
    const inputSearchData = searchParameters    
    const exclusiveNFilterParameters = inputSearchData.filter((parameter: { isExclusiveFilter: string; }) => parameter.isExclusiveFilter === "N");
    const request = {
      "searchText": sessionStorage.getItem("searchfeild") || '',
      "category": advFilter?.category || null,
      "subCategory": advFilter?.subCategory || null,
      "standPrgGrp": advFilter?.standard || null,
      "company": advFilter?.company || null,
      "location": advFilter?.location || null,
      "searchParameters": exclusiveNFilterParameters,
        "exclusiveSearchParameters":this.isValid(exclusiveYFilterParameters) ? exclusiveYFilterParameters :  [],
      "region": advSearchType === 'region' ? await this.getCountryNRegionValues('region') : null,
      "country": advSearchType === 'country' ? await this.getCountryNRegionValues('country'): null,
    }
    return request;
  }

  public getCountryNRegionValues(regionORCountry: string): Promise<any> {
    return new Promise((res, rej) => {
      let advFilter = JSON.parse(sessionStorage.getItem("advFilter") || 'null');
      let dataObj: any[] = [];
      if (advFilter?.facilityLocation && advFilter?.facilityLocation.length > 0) {
        if (regionORCountry === 'region') {
          advFilter?.facilityLocation?.forEach((region: any) => {
            const regionObj = {
              code: region.key,
              name: region.value
            }
            dataObj.push(regionObj);
          });
          res(dataObj);
        } else {
          advFilter?.facilityLocation?.forEach((country: any) => {
            const countryObj = {
              code: country.key,
              name: country.value,
              state: [] as any
            }
            if (advFilter?.state?.length > 0) {
              advFilter.state.forEach((state: any, index: number) => {
                if (country.key === state.key.split(',')[1]) {
                  const stateObj = {
                    code: state.key.split(',')[0],
                    name: state.value,
                  }
                  countryObj.state.push(stateObj);
                }
              });
            }
            dataObj.push(countryObj);
          });
          res(dataObj);
        }
      } else {
        res(null);
      }
    });
  }


  mobileAndTabletCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
    return check;
  };

  public isSmallScreen = function() {
    if (window.screen.width <= 768) {
      return true;
    } else {
      return false;
    }
  }

  isValid(exclusiveSearchFiltersVar: any[]) {
    let isValid = false;    
    exclusiveSearchFiltersVar.forEach(parameter => {
      if (parameter.isEditable === "Y" || parameter.isEditableValue === null || parameter.isEditableValue === "") {
        isValid = true;
      }
    });    
    return isValid;
  }

}
